import { Box, Typography } from "@mui/material";
import { motion, MotionConfig } from "motion/react";

function AnimatedStepTitle({ step, title }: { step: number; title: string }) {
  return (
    <MotionConfig transition={{ type: "spring", damping: 20, stiffness: 300 }}>
      <Box
        display="flex"
        flexDirection="column"
        pt={[3.5, 7.5]}
        rowGap={1}
        component={motion.div}
        key={step}
        variants={{ hide: { opacity: 0 }, show: { opacity: 1 } }}
        animate="show"
        initial="hide"
        transition={{ staggerChildren: 0.2 }}
        width="100%"
        pb={1.5}
      >
        <Typography
          color="text.primary"
          component={motion.span}
          variant="ui-4xl-bold"
          variants={{ hide: { opacity: 0, y: 4 }, show: { opacity: 1, y: 0 } }}
        >
          {title}
        </Typography>
      </Box>
    </MotionConfig>
  );
}

export default AnimatedStepTitle;
